import {
  Container,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
} from '@dapperlabs/core-fe';
import { useRouter } from 'next/router';
import { useSession } from 'src/edge/session';
import { useTranslation } from 'src/lib/translations';
import {
  MyMomentsList,
  MyPacksList,
  MyCollectionHeader,
} from 'src/modules/MomentsPageContent';
import {
  UserProfile,
  UserProfileWithoutPii,
} from 'src/modules/Queries/generated';
import { Box, Flex, useMultiStyleConfig } from 'src/theme';

interface MomentsPageContentProps {
  customTabs: any[];
  isOwnProfile?: boolean;
  locale: string;
  userProfile: UserProfile | UserProfileWithoutPii;
}

const MomentsPageContent = ({
  locale,
  userProfile,
  isOwnProfile,
  customTabs,
}: MomentsPageContentProps) => {
  const { t } = useTranslation();
  const router = useRouter();
  const { tab, tabList } = useMultiStyleConfig('Tab');
  const { state: sessionState } = useSession();

  const preferredLanguage = sessionState?.context?.preferredLanguage;
  return (
    <Box bg='linear-gradient(180deg, rgba(0, 36, 255, 0.7) 0%, #000000 128px)'>
      {!!userProfile && (
        <MyCollectionHeader
          isOwnProfile={isOwnProfile}
          locale={locale}
          userProfile={userProfile}
        />
      )}
      <Container as='main' maxW={['100%', '100%', '100%']} mt={[2, 2, 4]} p={0}>
        <Tabs mx={[0, 0, '10%']}>
          <TabList sx={tabList} pos='relative' mx={[4, 0]}>
            <Tab
              sx={tab}
              mx={{ base: 1, lg: '0.5rem' }}
              px={{ base: 0, sm: 2 }}
              color='#F0F2FD'
              fontFamily='main'
              fontSize='0.9rem'
              letterSpacing='0.019rem'
            >
              {t('MyMoments.Tabs.Moment.Label')}
            </Tab>
            <Tab
              sx={tab}
              mx={{ base: 1, lg: '0.5rem' }}
              px={{ base: 0, sm: 2 }}
              color='#F0F2FD'
              fontFamily='main'
              fontSize='0.9rem'
              letterSpacing='0.019rem'
            >
              {t('MyMoments.Tabs.Moment.Packs')}
            </Tab>
            {customTabs.map((customTab) => (
              <Flex
                key={customTab.path}
                sx={{
                  ...tab,
                  '&:hover': { color: '#bfbfbf' },
                  cursor: 'pointer',
                }}
                alignItems='flex-end'
                justifyContent='center'
                mx={{ base: 1, lg: '0.5rem' }}
                px={{ base: 0, sm: 2 }}
                py={2}
                color='#F0F2FD'
                fontFamily='main'
                fontSize='0.9rem'
                letterSpacing='0.019rem'
                textAlign='center'
                onClick={() =>
                  router.push(
                    `${process.env.NEXT_PUBLIC_SITE_URL}${customTab.path}`,
                  )
                }
              >
                {customTab.title}
              </Flex>
            ))}
          </TabList>

          <TabPanels px={['1rem', 0]}>
            <TabPanel mx={[0, 1]} px={[0, 1]}>
              {!!userProfile && (
                <MyMomentsList
                  flowAddress={userProfile.flowAddress}
                  preferredLanguage={preferredLanguage}
                />
              )}
            </TabPanel>
            <TabPanel>
              {!!userProfile && (
                <MyPacksList
                  flowAddress={userProfile.flowAddress}
                  isOwnProfile={isOwnProfile}
                  username={userProfile.username}
                />
              )}
            </TabPanel>
          </TabPanels>
        </Tabs>
      </Container>
    </Box>
  );
};

export default MomentsPageContent;
